import { ProductIds, UserRole } from '@/common/enums';
import { randomId } from '@/common/utils';
import { AuthRequest } from '@/views/auth/interfaces';
import { CompanyLicense, CompanyUser } from '@/views/companies/interfaces';
import { PLAY_PRODUCT } from './productsList';

export const USERS_CREDS: AuthRequest[] = [
  {
    email: 'camilo.garcia@craftsmanplus.com',
    password: 'Camilo123',
  },
  {
    email: 'alan.parsons@craftsmanplus.com',
    password: 'Camilo123',
  },
  {
    email: 'richard.stephens@craftsmanplus.com',
    password: 'Camilo123',
  },
  {
    email: 'deleted.user@someemaildomain.com',
    password: 'Camilo123',
  },
  {
    email: 'another.user@someemaildomain.com',
    password: 'Camilo123',
  },
  {
    email: 'new.user@craftsmanplus.com',
    password: 'Camilo123',
  },
  {
    email: 'external.user@nike.com',
    password: 'Camilo123',
  },
  {
    email: 'anna.anna@deletedcompany2.com',
    password: 'Camilo123',
  },
  {
    email: 'ssoduo@yopmail.com',
    password: 'Camilo123',
  },
  {
    email: 'external.user@adidas.com',
    password: 'Camilo123',
  },
];

export const BASE_USER = {
  id: randomId(),
  createdAt: 1644256455431,
  updatedAt: 1644256455431,
  lastLogin: 1644256455431,
  companies: [
    {
      id: '123',
      name: 'Craftsman+',
      logo: '',
    },
  ],
  groups: [],
  licenses: [],
  email: USERS_CREDS[0].email,
  firstName: 'Camilo',
  lastName: 'Garcia',
  isEmailConfirmed: false,
  isEnabled: true,
  jobTitle: 'Fancy Pants',
  phone: '+97334795153',
  roles: [{
    id: 1,
    name: UserRole.SYSTEM_ADMIN,
  }],
  permissions: [],
};

export const DUO_USER = {
  ...BASE_USER,
  id: 'u_ko2Bs',
  firstName: 'SSO',
  lastName: 'DUO',
  email: USERS_CREDS[8].email,
  roles: [{
    id: 3,
    name: UserRole.AUTHOR,
  }],
  permissions: [
    'asset:*',
    'me:view',
    'creative:view',
    'creative:create',
    'creative:edit',
    'creative:edit_others',
    'creative:delete',
    'creative:edit_others_template',
    'creative:edit_template',
    'creative:create_template',
    'creative:delete_others_template',
    'creative:delete_template',
    'creative:view_template',
    'creative:export',
    'creative:share',
    'creative:restore',
    'creative:duplicate',
    'creative:archive',
  ],
};

export const SYSTEM_ADMIN = {
  ...BASE_USER,
  id: 'u_ko2BK',
  email: USERS_CREDS[0].email,
  roles: [{
    id: 1,
    name: UserRole.SYSTEM_ADMIN,
  }],
  groups: [
    {
      id: 'g_ko2BK',
      name: 'Development',
    },
  ],
  licenses: [
    {
      id: PLAY_PRODUCT.id,
      totalUsers: 2,
      trial: false,
      seats: 2,
      durationLength: 30,
      productId: PLAY_PRODUCT.id,
      durationType: 'months',
      startDate: 1644256455431,
      isEnabled: true,
      product: PLAY_PRODUCT,
    },
  ] as CompanyLicense[],
  permissions: [
    '*:*',
  ],
};

export const CRAFTSMAN_ADMIN = {
  ...BASE_USER,
  id: 'u_ko2BK1',
  email: USERS_CREDS[2].email,
  firstName: 'Richard',
  lastName: 'Stephens',
  roles: [{
    id: 2,
    name: UserRole.CRAFTSMAN_ADMIN,
  }],
  groups: [
    {
      id: 'g_ko2BK1',
      name: 'Management',
    },
  ],
  permissions: [
    '*:*',
  ],
};

export const AUTHOR = {
  ...BASE_USER,
  id: randomId(),
  email: USERS_CREDS[1].email,
  firstName: 'Alan',
  lastName: 'Parsons',
  roles: [{
    id: 3,
    name: UserRole.AUTHOR,
  }],
  groups: [
    {
      id: 'g_ko2BK',
      name: 'Development',
    },
  ],
  licenses: [
    {
      id: PLAY_PRODUCT.id,
      totalUsers: 2,
      trial: false,
      seats: 2,
      durationLength: 30,
      productId: PLAY_PRODUCT.id,
      durationType: 'days',
      startDate: 1644256455431,
      isEnabled: false,
      product: PLAY_PRODUCT,
    },
  ],
  permissions: [
    'asset:*',
    'me:view',
    'creative:view',
    'creative:create',
    'creative:edit',
    'creative:edit_others',
    'creative:delete',
    'creative:edit_others_template',
    'creative:edit_template',
    'creative:create_template',
    'creative:delete_others_template',
    'creative:delete_template',
    'creative:view_template',
    'creative:export',
    'creative:share',
    'creative:restore',
    'creative:duplicate',
    'creative:archive',
  ],
};

export const DELETE_USER = {
  ...BASE_USER,
  id: 'u_ko2BK3',
  email: USERS_CREDS[3].email,
  firstName: 'Deleted',
  lastName: 'User',
  deletedAt: new Date('2022/04/01').toString(),
  deletedBy: [{
    createdAt: new Date('2022/04/01').toString(),
    user: { email: USERS_CREDS[0].email },
  }],
  roles: [{
    id: 4,
    name: UserRole.AUTHOR,
  }],
  companies: [
    {
      id: '146',
      name: 'Test(noDuration)',
      logo: '',
    },
  ],
  permissions: [
    'creative:view',
    'creative:edit',
  ],
};

export const DELETE_USER_2 = {
  ...BASE_USER,
  id: 'u_ko2BK4',
  email: USERS_CREDS[4].email,
  firstName: 'Deleted Craftsman+',
  lastName: 'User',
  deletedAt: new Date('2022/03/01').toString(),
  deletedBy: [{
    createdAt: new Date('2022/03/01').toString(),
    user: { email: USERS_CREDS[0].email },
  }],
  roles: [{
    id: 4,
    name: UserRole.AUTHOR,
  }],
  companies: [
    {
      id: '123',
      name: 'Craftsman+',
      logo: '',
    },
  ],
};

export const DELETE_USER_3 = {
  ...BASE_USER,
  id: 'u_ko2BK5',
  email: USERS_CREDS[7].email,
  firstName: 'Anna',
  lastName: 'Kolomiitseva',
  roles: [{
    id: 4,
    name: UserRole.AUTHOR,
  }],
  companies: [
    {
      id: '9999',
      name: 'Deleted Company 2',
      logo: '',
    },
  ],
};

export const AuthorUserPlayLicense: CompanyLicense = {
  id: ProductIds.PLAY,
  trial: false,
  seats: 10,
  durationLength: 12,
  productId: 2,
  durationType: 'months',
  startDate: '2023-01-01T08:04:55.000Z',
  totalUsers: null,
  isEnabled: true,
  product: PLAY_PRODUCT,
};

export const NEW_USER = {
  ...BASE_USER,
  id: randomId(),
  firstName: 'New',
  lastName: 'User',
  email: USERS_CREDS[5].email,
  roles: [{
    id: 4,
    name: UserRole.AUTHOR,
  }],
  permissions: [
    'asset:*',
    'me:view',
    'creative:view',
    'creative:create',
    'creative:edit',
    'creative:edit_others',
    'creative:delete',
    'creative:edit_others_template',
    'creative:edit_template',
    'creative:create_template',
    'creative:delete_others_template',
    'creative:delete_template',
    'creative:view_template',
    'creative:export',
    'creative:share',
    'creative:restore',
    'creative:duplicate',
    'creative:archive',
  ],
  licenses: [AuthorUserPlayLicense],
};

export const EXTERNAL_USER = {
  ...AUTHOR,
  id: randomId(),
  email: USERS_CREDS[6].email,
  firstName: 'External',
  lastName: 'User',
  companies: [
    {
      id: '789',
      name: 'Nike',
      logo: '',
    },
  ],
};

export const ADIDAS_USER = {
  ...EXTERNAL_USER,
  id: randomId(),
  email: USERS_CREDS[9].email,
  firstName: 'Paula',
  lastName: 'Claure',
  roles: [{
    id: 4,
    name: UserRole.AUTHOR,
  }],
  companies: [
    {
      id: '346',
      name: 'Adidas',
      logo: '',
    },
  ],
};

export const USERS: CompanyUser[] = [
  SYSTEM_ADMIN,
  CRAFTSMAN_ADMIN,
  AUTHOR,
  DELETE_USER,
  DELETE_USER_2,
  DELETE_USER_3,
  NEW_USER,
  EXTERNAL_USER,
  DUO_USER,
  ADIDAS_USER,
];
